export const settingPaths = {
  ACCOUNT_SETTING: "account",
};
